const ipcurrent = (state = [], action) => {
  switch (action.type) {
    case "ADD_IPCURRENT":
      return {
        type: "ADD_IPCURRENT",
        ip: action.ip,
        audio: action.audio,
        difftime: action.difftime,
        audiomessage: action.audiomessage,
        audiocall: action.audiocall,
        midias: action.midias,
        isLoginComplete: false,
        idlogin: action.idlogin
      };
    case "CHANGE_AUDIO_INTERACTION":
      return {
        ...state,
        audio: action.post,
      };
    case "CHANGE_AUDIO_MESSAGE":
      return {
        ...state,
        audiomessage: action.post,
      };
    case "CHANGE_AUDIO_CALL":
      return {
        ...state,
        audiocall: action.post,
      };
    case "CHANGE_LOGIN_COMPLETE":
      return {
        ...state,
        isLoginComplete: action.post,
      };
    default:
      return state;
  }
};

export default ipcurrent;
